import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import RadioGroup from './../RadioGroup'
import { withTranslation, Trans } from 'react-i18next'
import './Xr41Sprayhood.css'
import { exteriorView08ImageOptions } from './views/ExteriorView08'

class Xr41Sprayhood extends Component {
  constructor (props) {
    super(props)
    this.handleSprayhoodChange = this.handleSprayhoodChange.bind(this)
    this.handleMastAndBoomChange = this.handleMastAndBoomChange.bind(this)
    this.handleBoomCoverChange = this.handleBoomCoverChange.bind(this)
  }

  handleSprayhoodChange (newValue) {
    let configuration = this.props.configuration
    configuration.Sprayhood = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleMastAndBoomChange (newValue) {
    let configuration = this.props.configuration
    configuration.MastAndBoom = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleBoomCoverChange (newValue) {
    let configuration = this.props.configuration
    configuration.BoomCover = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

    render() {
        let imageOptions = exteriorView08ImageOptions;

    let image = (
      <ConfiguratorImage
        boat='Xr41'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
                    <Trans defaults='Sprayhood & Boom cover' />
          </h1>

          <p>
                    <Trans defaults='The sprayhood can be stored (including the canvas) in the deck recess. ' />
          </p>

          <div className="xr41rigging-groups">
            <RadioGroup
              label={this.props.t('Sprayhood options:')}
              options={this.props.sprayhoodOptions}
              value={this.props.configuration.Sprayhood}
              onChange={this.handleSprayhoodChange}
            />


            <RadioGroup
              label={this.props.t('Boom Cover options:')}
              options={this.props.boomCoverOptions}
              value={this.props.configuration.BoomCover}
              onChange={this.handleBoomCoverChange}
            />
          </div>
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(Xr41Sprayhood)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41Sprayhood.js